var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"badge",class:{ 'badge--can-remove' : _vm.canRemove },style:({
        backgroundColor: _vm.bgColor,
        color: _vm.textColor
    })},[_vm._t("default"),_vm._v(" "),(_vm.canRemove)?_c('to-icon-button',{staticClass:"sz-1",on:{"click":function($event){return _vm.$emit('remove')}}},[_c('to-icon',{attrs:{"name":"ex"}})],1):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }